import { useState, useEffect } from 'react';
import apiUrl from '../../utils/apiUrl';

const useResults = (programId) => {
  const [campaignData, setCampaignData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCampaignData = async () => {
      setLoading(true);
      try {
        // Decode URL parameter properly
        const formattedId = programId.replace(/_/g, '%20');

        const response = await fetch(
          `${apiUrl.apiUrl}/programResults/program/${formattedId}`
        );

        if (!response.ok) {
          throw new Error(`Error fetching campaign info: ${response.status}`);
        }

        const data = await response.json();

        if (!data) {
          throw new Error('Campaign not found');
        }

        setCampaignData(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching campaign info:', error.message);
        setError(error.message);
        setCampaignData(null);
      } finally {
        setLoading(false);
      }
    };

    if (programId) {
      fetchCampaignData();
    }
  }, [programId]); // Only depend on programId, not on campaignData

  return { campaignData, loading, error };
};

export default useResults;
